import React, { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import './LoginForm.css'

function NewPasswordForm() {
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [localError, setLocalError] = useState('')

  const { completeNewPassword, error, clearError } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    setLocalError('')

    // Validation
    if (!newPassword || !confirmPassword) {
      setLocalError('Please fill in all fields')
      setIsLoading(false)
      return
    }

    if (newPassword !== confirmPassword) {
      setLocalError('Passwords do not match')
      setIsLoading(false)
      return
    }

    if (newPassword.length < 8) {
      setLocalError('Password must be at least 8 characters long')
      setIsLoading(false)
      return
    }

    // Check password requirements
    const hasUpperCase = /[A-Z]/.test(newPassword)
    const hasLowerCase = /[a-z]/.test(newPassword)
    const hasNumbers = /\d/.test(newPassword)

    if (!hasUpperCase || !hasLowerCase || !hasNumbers) {
      setLocalError('Password must contain uppercase, lowercase, and numbers')
      setIsLoading(false)
      return
    }

    try {
      const result = await completeNewPassword(newPassword)
      
      if (result.success) {
        // Redirect to the page they were trying to access or home
        const from = location.state?.from?.pathname || '/'
        navigate(from, { replace: true })
      } else {
        setLocalError(result.error || 'Failed to set new password')
      }
    } catch {
      setLocalError('An unexpected error occurred')
    } finally {
      setIsLoading(false)
    }
  }

  const displayError = localError || error

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>Set New Password</h1>
          <p>Please set a new password for your account</p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          {displayError && (
            <div className="error-message">
              {displayError}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="newPassword">New Password</label>
            <input
              type="password"
              id="newPassword"
              value={newPassword}
              onChange={(e) => {
                setNewPassword(e.target.value)
                if (localError) setLocalError('')
                if (error) clearError()
              }}
              placeholder="Enter your new password"
              required
              autoComplete="new-password"
            />
            <div className="password-requirements">
              <small>Must be 8+ characters with uppercase, lowercase, and numbers</small>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">Confirm New Password</label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => {
                setConfirmPassword(e.target.value)
                if (localError) setLocalError('')
                if (error) clearError()
              }}
              placeholder="Confirm your new password"
              required
              autoComplete="new-password"
            />
          </div>

          <button 
            type="submit" 
            className="auth-button primary"
            disabled={isLoading}
          >
            {isLoading ? 'Setting Password...' : 'Set New Password'}
          </button>
        </form>
      </div>
    </div>
  )
}

export default NewPasswordForm